/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AiPlanningEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const aiPlanningEntrypoint: EntryPoint<
	AiPlanningEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<AiPlanningEntrypointComponent>(
		/* webpackChunkName: "async-ai-planning-app" */ './AiPlanningApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (_entryPointRouteParams: EntryPointRouteParams) => ({}),
});
